export const pnl_type = {
  1: "Day P&L",
  2: "Weekly P&L",
  3: "Monthly P&L",
  4: "Custom P&L",
};

export const pnl_segments = {
  1: "Equity",
  2: "F&O",
  3: "Commodity",
  4: "Currency",
  5: "MF",
};

export const error_messages = {
  INVALID_LINK: {
    header: "Oh-oh! Something went wrong!",
    message: "Looks like the link you followed can't be accessed.",
    sub_message: "Please try again later.",
  },
  EXPIRED_LINK: {
    header: "Oh-oh! Invalid link!",
    message:
      "The link you are attempting to access has been deleted by the user and is no longer available.",
    sub_message: "Please try contacting the user for further information.",
  },
};
